/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Chapter } from 'components/chapter'

// TODO Set the correct article ID here
const ARTICLE_ID = '398164899620'

export function AppComponent() {
  const [groups, setGroups] = useState({})
  const [comment, setComment] = useState({})
  const [texts, setTexts] = useState({})

  useEffect(() => {
    fetch(
      'https://interaktiv.tagesanzeiger.ch/datenteam/russia_economy_dashboard/Datawrappers.json'
    )
      .then(response => response.json())
      .then(data => {
        const distinct = {}
        Object.values(data).map(m => {
          const gruppe = m.Gruppe.trim()
          if (gruppe) {
            if (!(gruppe in distinct)) {
              distinct[gruppe] = {}
            }
            if (!('charts' in distinct[gruppe])) {
              distinct[gruppe].charts = []
            }
            distinct[gruppe].charts.push({
              titel: m.Titel,
              untertitel: m.Untertitel,
              link: m.Link
            })
          }
        })
        setGroups(distinct)
      })
  }, [])

  useEffect(() => {
    fetch(
      'https://interaktiv.tagesanzeiger.ch/datenteam/russia_economy_dashboard/Boxen.json'
    )
      .then(response => response.json())
      .then(data => {
        const distinct = {}
        Object.values(data).map(m => {
          const gruppe = m.Gruppe.trim()
          if (gruppe) {
            if (!(gruppe in distinct)) {
              distinct[gruppe] = m.Text
            }
          }
        })
        setComment(distinct)
      })
  }, [])

  useEffect(() => {
    fetch(
      'https://interaktiv.tagesanzeiger.ch/datenteam/russia_economy_dashboard/Titel_Lead.json'
    )
      .then(response => response.json())
      .then(data => {
        setTexts(Object.values(data))
      })
  }, [])

  const chapters = Object.keys(groups).map(key => (
    <Chapter
      key={key}
      category={key}
      charts={groups[key].charts}
      comment={comment[key]}
    />
  ))

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>{texts[0] !== undefined ? texts[0].Titel : null}</h1>
            <h2>{texts[0] !== undefined ? texts[0].Lead : null}</h2>
          </div>
        </div>
      </header>

      <div
        style={{ marginBottom: '0', paddingBottom: '0' }}
        className='ui vertical segment'
      >
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Patrick Meier, Svenson Cornehls, Dominik Balmer
            </div>
            <div className='ta updated'>Wird laufend aktualisiert</div>
          </div>
        </div>
      </div>

      {chapters}

      <Footer
        articleId={ARTICLE_ID}
        mailTo='daten@tamedia.ch'
        question='Haben Sie Anmerkungen, oder haben Sie einen Fehler entdeckt?'
        credits={[
          [
            'Konzept & Umsetzung',
            'Patrick Meier, Svenson Cornehls, Dominik Balmer'
          ]
        ]}
      />
    </div>
  )
}
